module.exports = __webpack_public_path__ + "static/media/Kobe.fc6a5a8d.mp4";